import { Router, UrlTree } from '@angular/router';
import { SessionUser } from '@core/auth/auth-session.model';
import { hasCreateBusinessIntent } from '@core/auth/create-business-intent.storage';
import { AdminShellModeService } from '@core/shell/admin-shell-mode.service';
import { LocationContextService } from '@core/tenant/location-context.service';
import { TenantContextService } from '@core/tenant/tenant-context.service';
import { isStaffEmailVerified } from '@features/auth/utils/staff-email-verified.util';
import { resolvePostLoginDestination } from '@features/auth/utils/resolve-post-login-destination.util';

export type StaffAuthRedirectDeps = {
  user: SessionUser;
  router: Router;
  tenantContext: TenantContextService;
  locationContext: LocationContextService;
  adminShellMode: AdminShellModeService;
};

/** Aplica contexto tenant/sede y devuelve la UrlTree post-auth staff (email verificado o no). */
export function createStaffAuthUrlTree(deps: StaffAuthRedirectDeps): UrlTree {
  const { user, router, tenantContext, locationContext, adminShellMode } = deps;

  if (!isStaffEmailVerified(user)) {
    return router.createUrlTree(['/authentication/verify-email']);
  }

  if (hasCreateBusinessIntent()) {
    tenantContext.clear();
    locationContext.clear();
    adminShellMode.setMode('tenant');
    return router.createUrlTree(['/onboard']);
  }

  const destination = resolvePostLoginDestination(user);

  if (destination.kind === 'onboard') {
    return router.createUrlTree(['/onboard']);
  }
  if (destination.kind === 'platform') {
    adminShellMode.applyPostLoginDefaultForSuperadmin();
    return router.createUrlTree(['/platform/tenants']);
  }
  if (destination.kind === 'choose-workspace') {
    return router.createUrlTree(['/authentication/choose-workspace']);
  }

  tenantContext.setActiveCompany(destination.companyId);
  if (destination.locationId != null) {
    locationContext.setActiveLocation(destination.locationId);
  } else {
    locationContext.clear();
  }
  adminShellMode.setMode('tenant');
  return router.parseUrl(destination.entryUrl ?? '/dashboard');
}
